// A boulder: one chunky faceted icosahedron squashed and tilted into a rock
// shape, with a smaller stone nestled against it. Ported 1:1 from age-of-mcp's
// classic rock.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.34, 0),
      color: "#7a808b", position: [0, 0.22, 0],
      rotation: [0.3, 0.7, 0.15], scale: [1.35, 0.82, 1.15] },
    { geometry: new THREE.IcosahedronGeometry(0.2, 0),
      color: "#9aa3ad", position: [0.26, 0.13, 0.12],
      rotation: [0.5, 1.4, 0.2], scale: [1.2, 0.8, 1.0] },
  ];
}

export const rock = defineModel({
  id: "rock",
  batchId: "standard",
  name: "Rock",
  tags: ["scenery","rock","low-poly","age-of-mcp","classic"],
  summary: "Low-poly rock.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.42,
  parts: () => partsFor(),
  animations: [],
});
